import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutPropertiesLoose from '@babel/runtime/helpers/objectWithoutPropertiesLoose';
import React__default, { forwardRef } from 'react';
import c from 'classnames';
import BaseIconButton from '../BaseIconButton/BaseIconButton.js';
import { COLOR_CLASSES, TEXT_COLOR_CLASSES, ICONBUTTON_SIZE, BORDER_RADIUS } from '../utils/utils.js';

var _excluded = ["appearance", "children", "className", "Icon", "shape", "size", "variant"];
var DeprecatedIconButton = /*#__PURE__*/forwardRef(function (props, ref) {
  var _props$appearance = props.appearance,
    appearance = _props$appearance === void 0 ? 'primary' : _props$appearance,
    children = props.children,
    className = props.className,
    Icon = props.Icon,
    _props$shape = props.shape,
    shape = _props$shape === void 0 ? 'theme' : _props$shape,
    _props$size = props.size,
    size = _props$size === void 0 ? 'medium' : _props$size,
    _props$variant = props.variant,
    variant = _props$variant === void 0 ? 'filled' : _props$variant,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  var sizeClasses = ICONBUTTON_SIZE[size];
  var shapeClasses = BORDER_RADIUS[shape];
  var colorClasses = COLOR_CLASSES[variant][appearance];
  var textColorClasses = TEXT_COLOR_CLASSES[variant][appearance];
  return /*#__PURE__*/React__default.createElement(BaseIconButton, _extends({
    ref: ref,
    className: c('flex py-0 items-center', sizeClasses, shapeClasses, colorClasses, textColorClasses, className)
  }, rest), Icon ? /*#__PURE__*/React__default.createElement(Icon, null) : children);
});

export { DeprecatedIconButton as default };
//# sourceMappingURL=DeprecatedIconButton.js.map
